import React, { useState, useContext, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import client from '../../api/graphql/graphqlAPI';
import Uploader from '../Views/Mam/Uploader';
import GalleryObject from './GalleryObject';

const GET_OBJECTS_LIST = gql`
  query getMamObjectsList($type: [String], $offset: Int, $limit: Int) {
    getMamObjectsList(type: $type, offset: $offset, limit: $limit) {
      assetSlugName
      isPublic
      url
      fileExtension
      type
      tags
      fileReadableName {
        en
      }
    }
  }
`;

const className = 'w-115px h-115px';

const GalleryCreate = (props) => {
  const {
    selectedObjects, setObjects, showForm, setShowForm, type,
  } = props;

  const [mamObjectsList, setMamObjectsList] = useState([]);

  const { loading, error, data } = useQuery(GET_OBJECTS_LIST, {
    client,
    variables: {
      type,
    },
    pollInterval: 1000,
  });

  if (error) return <p>{error}</p>;

  return (
    <>
      <div className="flex">
        <div className="flex flex-col">
          <Uploader />
          {
            data && (
              <div className="w-full flex flex-row flex-wrap h-96 xxxl:h-carouselMD overflow-y-auto justify-center mb-6">
                {
                data.getMamObjectsList.map(obj => <GalleryObject {...obj} setObjects={setObjects} className={className} key={obj.assetSlugName} selected={selectedObjects && selectedObjects.some(i => i.assetSlugName === obj.assetSlugName)} />)
                }
              </div>

            )
          }

        </div>
        {selectedObjects && selectedObjects.length > 0 && (
          <div className="w-550px">
            <div className="flex flex-col mt-4 w-550px">
              <div className="bg-greyFilter flex flex-row justify-around items-center rounded-t-lg h-80px">
                <p className="font-americaMonoBold text-xs uppercase m-0">Your Selection</p>
                <button type="button" className="font-americaMonoBold text-xs px-7 rounded-full bg-black py-3 text-white uppercase" onClick={() => setShowForm(!showForm)}>
                  Continue
                </button>
              </div>
            </div>
            <div className="bg-greyFilterItems rounded-b-lg flex flex-row flex-wrap pt-4 pb-2 overflow-y-auto max-h-35 xxxl:max-h-43 justify-center">
              {selectedObjects.map(obj => (
                <GalleryObject {...obj} setObjects={setObjects} className={className} cursor key={obj.assetSlugName} />
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

GalleryCreate.propTypes = {
  selectedObjects: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  setObjects: PropTypes.func.isRequired,
  showForm: PropTypes.bool.isRequired,
  setshowForm: PropTypes.func,
};

GalleryCreate.defaultProps = {
  setshowForm: null,
};

export default GalleryCreate;
